<template>
  <div>
    <main-template>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col>
              <h1>
                <v-btn color="primary" x-small text @click="goBack">
                  <v-icon left>fa fa-angle-left</v-icon>
                </v-btn>
                {{ editing ? "Editando" : "Criando" }} Planejamento de Aulas
              </h1>
            </v-col>
          </v-row>

          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(createOrUpdate)">
              <v-row>
                <!-- Campo de Escola/Professor -->
                <v-col cols="12" md="6" class="pt-8 pb-0">
                  <ValidationProvider name="Escola" rules="required" v-slot="{ errors }">
                    <e-label>Escola</e-label>
                    <e-autocomplete
                      v-model="form.configuracao_id"
                      :items="franquias"
                      item-text="descricao"
                      item-value="id"
                      :error-messages="errors"
                      label="Selecione uma escola"
                      dense
                      solo
                    />
                  </ValidationProvider>
                </v-col>

                <!-- Campo de Data -->
                <v-col cols="12" md="6" class="pt-8 pb-0">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="form.data"
                    persistent
                    width="450px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                        <e-label>Selecione uma data</e-label>
                        <v-text-field
                          v-model="dataFormatada"
                          label="Escolha uma data"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          solo
                          :error-messages="errors"
                          prepend-inner-icon="mdi-calendar"
                        />
                      </ValidationProvider>
                    </template>

                    <v-card>
                      <v-date-picker
                        v-model="form.data"
                        full-width
                        scrollable
                        color="primary"
                        header-color="primary"
                      />

                      <v-divider />

                      <v-card-actions>
                        <v-spacer />
                        <v-btn text color="primary" @click="modal = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="salvarData"> OK </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <!-- Botões de ação -->
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="error" class="mr-2" @click="goBack"> Cancelar </v-btn>
                  <v-btn color="success" type="submit" :loading="submittingForm">
                    {{ editing ? "Atualizar" : "Salvar" }}
                  </v-btn>
                </v-col>
              </v-row>
            </form>
          </ValidationObserver>
        </v-col>
      </v-row>
    </main-template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PlanejamentoAulasForm",

  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      escola: {
        id: null,
        descricao: null,
      },
      modal: false,
      submittingForm: false,
      form: {
        configuracao_id: null,
        data: null,
      },
      franquias: [],
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList"]),
    dataFormatada() {
      if (!this.form.data) return "";
      const [ano, mes, dia] = this.form.data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    salvarData() {
      this.$refs.dialog.save(this.form.data);
    },

    async loadData() {
      await this.$services.franquiasService.syncAll();
      if (!this.user.franquias_permitidas) {
        this.franquias = [...this.franquiasList];
      } else {
        this.franquias = this.franquiasList.filter((franquia) =>
          this.user.franquias_permitidas.includes(franquia.id)
        );
      }
    },

    async loadfranquias() {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.franquiasService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async createOrUpdate() {
      this.submittingForm = true;
      try {
        if (this.editing) {
          // await this.$services.planejamentoService.update(this.$route.params.id, this.form)
          this.$toast.success("Planejamento atualizado com sucesso!");
        } else {
          await this.$services.gestoesDeAulasService.createPlanejamentoAulas(this.form);
          this.$toast.success("Planejamento criado com sucesso!");
        }
        this.goBack();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
  },
};
</script>

<style scoped></style>
